// The look inside a product (AdminAddProduct.dc.html, step 3): 5 looks, and for its own look the 3
// colours, a heading font and the 3-line contrast check. Used by Add a product and, while a product is
// a draft, by its settings. value: { look, ownBg, ownAccent, ownText, font }. looks: the looks its type's
// pages are drawn in (model.js looksFor), every look by default; with only 1, fixed says why in place
// of the look's own note.
import { useId } from 'react'
import { ADD, LOOK_NAMES } from './copy.js'
import { LOOKS, LOOK_ORDER, FONTS, contrastCheck, ratioText, isHex, normalHex } from './model.js'

export function LookPicker({ value, onChange, disabled, looks = LOOK_ORDER, fixed = null }) {
  const id = useId()
  const own = { bg: normalHex(value.ownBg), accent: normalHex(value.ownAccent), text: normalHex(value.ownText) }
  const check = contrastCheck(own)
  const note = looks.length === 1 && fixed ? fixed
    : value.look === 'master' ? ADD.lookNotes.master : value.look === 'own' ? ADD.lookNotes.own : ADD.lookNotes.family
  const result = r => (r.ratio === null ? ADD.needsHex : ADD.contrastResult(ratioText(r.ratio), r.pass))
  return (
    <>
      <div className="ap-looks" role="radiogroup" aria-label={ADD.lookH2}>
        {looks.map(key => {
          const sw = key === 'own' ? [isHex(own.bg) ? own.bg : '#FFFFFF', isHex(own.accent) ? own.accent : '#0D0D0D'] : [LOOKS[key].bg, LOOKS[key].accent]
          return (
            <button key={key} type="button" role="radio" aria-checked={value.look === key} className="ap-opt ap-look" disabled={disabled}
              onClick={() => onChange({ look: key })}>
              <span className="ap-swatches" aria-hidden="true">
                <span className="ap-swatch" style={{ background: sw[0] }} />
                <span className="ap-swatch ap-swatch--2" style={{ background: sw[1] }} />
              </span>
              <span className="ap-opt-text"><span className="ap-opt-name">{LOOK_NAMES[key][0]}</span><span className="ap-opt-note">{LOOK_NAMES[key][1]}</span></span>
            </button>
          )
        })}
      </div>
      <p className="ap-step-line">{note}</p>
      {value.look === 'own' && (
        <>
          <div className="ap-own-colours">
            {[['ownBg', ADD.background], ['ownAccent', ADD.accent], ['ownText', ADD.text]].map(([k, label]) => (
              <div className="ad-field" key={k}>
                <label className="ap-flabel" htmlFor={`${id}-${k}`}>{label}</label>
                <input id={`${id}-${k}`} className="ad-input" value={value[k]} disabled={disabled} spellCheck={false} autoComplete="off"
                  aria-invalid={isHex(value[k]) ? undefined : true} onChange={e => onChange({ [k]: e.target.value })} />
              </div>
            ))}
          </div>
          <div className="ad-field">
            <span className="ap-flabel" id={`${id}-font`}>{ADD.headingFont}</span>
            <div className="ap-fonts" role="radiogroup" aria-labelledby={`${id}-font`}>
              {FONTS.map(f => (
                <button key={f.key} type="button" role="radio" aria-checked={value.font === f.key} className="ap-font" disabled={disabled}
                  style={{ fontFamily: f.family, fontWeight: f.weight }} onClick={() => onChange({ font: f.key })}>{f.name}</button>
              ))}
            </div>
            <p className="ad-hint">{ADD.fontNote}</p>
          </div>
          <div className="ap-contrast" role="status" aria-live="polite">
            <span className="ap-contrast-h">{ADD.contrastH3}</span>
            {check.rows.map(r => (
              <span className="ap-contrast-row" key={r.key}>
                <span className="ap-contrast-what">{r.key === 'text' ? ADD.contrastText : r.key === 'button' ? ADD.contrastButton(r.ink) : ADD.contrastEdge}</span>
                <span className="ap-contrast-result">{result(r)}</span>
              </span>
            ))}
            <span className="ap-contrast-note">{check.pass ? ADD.contrastPass : ADD.contrastFail}</span>
          </div>
        </>
      )}
    </>
  )
}
